import React from 'react';
import styled from 'styled-components';
import { colors, typography, spacing } from '../styles/designTokens';
import { MainContent } from '../styles/DashboardStyles';

const DesktopWrap = styled(MainContent)`
  background: ${colors.secondary[50]};
  min-height: 60vh;
`;

const MobileWrap = styled.div`
  min-height: 40vh;
`;

const Inner = styled.div`
  padding: ${spacing[6]};
  max-width: 42rem;
`;

const InnerMobile = styled.div`
  padding: ${spacing[4]};
  max-width: 42rem;
`;

const Title = styled.h1`
  margin: 0 0 ${spacing[3]} 0;
  font-size: ${typography.fontSize['2xl']};
  font-weight: ${typography.fontWeight.bold};
  color: ${colors.semantic.text.primary};
`;

const TitleMobile = styled.h1`
  margin: 0 0 ${spacing[3]} 0;
  font-size: ${typography.fontSize.xl};
  font-weight: ${typography.fontWeight.bold};
  color: ${colors.semantic.text.primary};
`;

const Desc = styled.p`
  margin: 0;
  font-size: ${typography.fontSize.base};
  color: ${colors.semantic.text.secondary};
  line-height: ${typography.lineHeight.relaxed};
`;

const DescMobile = styled.p`
  margin: 0;
  font-size: ${typography.fontSize.sm};
  color: ${colors.semantic.text.secondary};
  line-height: ${typography.lineHeight.relaxed};
`;

export interface PlaceholderPageProps {
  title: string;
  description: string;
  /** MainLayoutMobile 내부에서는 false (MainContent의 모바일 헤더 패딩과 충돌 방지) */
  shell?: 'desktop' | 'mobile';
}

/** 라우트 플레이스홀더 — 인벤토리 `/keywords` 등과 동일 패턴을 토큰으로 통일 */
const PlaceholderPage: React.FC<PlaceholderPageProps> = ({
  title,
  description,
  shell = 'desktop',
}) =>
  shell === 'mobile' ? (
    <MobileWrap>
      <InnerMobile>
        <TitleMobile>{title}</TitleMobile>
        <DescMobile>{description}</DescMobile>
      </InnerMobile>
    </MobileWrap>
  ) : (
    <DesktopWrap>
      <Inner>
        <Title>{title}</Title>
        <Desc>{description}</Desc>
      </Inner>
    </DesktopWrap>
  );

export default PlaceholderPage;
